import { Component, OnInit } from '@angular/core';
import { ReportPageBase } from 'src/shared/Baseclasses/report-page-base';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { Constants } from 'src/shared/utilities/constants.util';
import { ReportService } from 'src/shared/services/report.service';
import { ReportConstants } from '../../shared/report-constants.util';

@Component({
  selector: 'smt-acuity-trends-page',
  templateUrl: './acuity-trends-page.component.html',
  styleUrls: ['./acuity-trends-page.component.scss']
})
export class AcuityTrendsPageComponent extends ReportPageBase implements OnInit   { 
  views:string[];
  defaultView:string;
  
  constructor(private reportService: ReportService){
    super();
  }
  
  ngOnInit() {
    this.views = [ 
        ReportConstants.DateViewLabel, 
        ReportConstants.DayOfWeekViewLabel, 
        ReportConstants.PeriodEndViewLabel, 
        ReportConstants.ShiftBlockViewLabel, 
        ReportConstants.WeekViewLabel 
    ];
    this.defaultView = ReportConstants.DateViewLabel;
    this.reportService.announceSummarySelected(Constants.AcuitySummary);
  }

  filterUpdated(filters:ReportFilters){
    this.filters = filters;
    this.filterEventsSubject.next();
  }

}
